function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 17C0 7.61116 7.61116 0 17 0C26.3888 0 34 7.61116 34 17C34 26.3888 26.3888 34 17 34C7.61116 34 0 26.3888 0 17Z",
  fill: "#F2F2F7"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 11.75,
  y: 7.75,
  width: 10.5,
  height: 18.5,
  rx: 2.25,
  stroke: "#141233",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 7.95239H19.5V8.85715C19.5 9.40944 19.0523 9.85715 18.5 9.85715H15.5C14.9477 9.85715 14.5 9.40944 14.5 8.85715V7.95239Z",
  fill: "#141233"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7031 19.875C15.8594 20.0312 16.125 20.0312 16.2812 19.875L20.875 15.2812C21.0312 15.125 21.0312 14.8594 20.875 14.7031L20.3125 14.1406C20.1562 13.9844 19.9062 13.9844 19.75 14.1406L16 17.8906L14.2344 16.1406C14.0781 15.9844 13.8281 15.9844 13.6719 16.1406L13.1094 16.7031C12.9531 16.8594 12.9531 17.125 13.1094 17.2812L15.7031 19.875Z",
  fill: "#141233"
});

var SvgPhoneChecked = function SvgPhoneChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone-checked.c2ef22e3.svg";
export { ForwardRef as ReactComponent };